import script from "./NewsPageStoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageStoryModal.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageStoryModal.vue?vue&type=style&index=0&id=a6e5aee6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6e5aee6"]])

export default __exports__